/** @jsx jsx */
import { jsx, Box } from 'theme-ui';
import { useTranslation } from 'react-i18next';
import Link from '../../components/Link';
import { Button } from '..';
import Widget from './Widget';
import { formatPrice } from '../../utils/formatters';
import moment from 'moment';

export default (props) => {
  const { t: translate } = useTranslation();

  const titleColor = props?.frontPage ? 'primary' : undefined;
  const bgColor = props?.frontPage ? '#F9B8CB' : undefined;
  const color = props?.frontPage ? 'black' : undefined;

  const price = moment().isSameOrAfter('2026-08-03', 'day') ? 5.9 : 6.8;

  return (
    <Widget
      title={translate('sendParcelWidget.title')}
      titleColor={titleColor || 'pinkDark'}
      bg={bgColor}
      color={color}
      {...props}
    >
      <Box sx={{ fontSize: [2, 18] }}>{translate('sendParcelWidget.description', { price: formatPrice(price) })}</Box>
      <Box sx={{ mt: 3 }}>
        <Button
          variant="secondary"
          as={Link}
          to="/osta-paketti"
          sx={{
            bg: props?.frontPage ? 'newBlue' : 'undefined',
            color: props?.frontPage ? 'white' : 'undefined',
            border: props?.frontPage ? 0 : undefined,
          }}
        >
          {translate('sendParcelWidget.buyAndSendParcel')}
        </Button>
      </Box>
    </Widget>
  );
};
